import { TFunction } from 'i18next'

import { RecurringInvoiceFrequency } from '../enums/recurringInvoiceFrequency'

const frequencyTKeys = {
  [RecurringInvoiceFrequency.Biweekly]: 'recurring_invoices.frequency.option.biweekly',
  [RecurringInvoiceFrequency.Monthly]: 'recurring_invoices.frequency.option.monthly',
  [RecurringInvoiceFrequency.MonthlyLastDay]: 'recurring_invoices.frequency.option.monthly_last_day',
  [RecurringInvoiceFrequency.Quarterly]: 'recurring_invoices.frequency.option.quarterly',
  [RecurringInvoiceFrequency.Semiannually]: 'recurring_invoices.frequency.option.semiannually',
  [RecurringInvoiceFrequency.Weekly]: 'recurring_invoices.frequency.option.weekly',
  [RecurringInvoiceFrequency.Yearly]: 'recurring_invoices.frequency.option.yearly',
}

export const getRecurringInvoiceFrequencyLabel = (frequency: RecurringInvoiceFrequency | undefined, t: TFunction) => {
  return frequency ? t(frequencyTKeys[frequency]) : ''
}
